import styled from 'styled-components';

const BlogListItemStyle = styled.div`
	&.blogItem {
		--imgSize: 72%;
		--itemMargTop: var(--sp4x);
		--itemMargBottom: var(--sp6x);
		--blogItemInfoTop: 0;

		position: relative;
		z-index: 11;
		background-color: var(--color1);
		border-top: 2px solid var(--color2);

		a {
			height: 100%;
			display: block;
		}

		&.none {
			pointer-events: none;
		}

		&:after {
			content: '';
			position: absolute;
			height: calc(var(--itemMargBottom) - 2px);
			top: calc(var(--itemMargBottom) * -1);
			left: var(--containerPaddingLR);
			right: 0;
			background-color: var(--color1);
			border-top-left-radius: var(--sp3x);
		}

		&:first-child {
			&:after {
				content: none;
			}
		}

		.blogCont {
			padding-top: var(--itemMargTop);
			padding-bottom: var(--itemMargBottom);

			.blogItemInfo {
				padding-top: var(--blogItemInfoTop);

				.blogItemDate {
					position: absolute;
					top: 0;
					left: var(--containerPaddingLR);
					z-index: 11;
					display: inline-block;
					border-top-left-radius: var(--sp3x);
					border-top-right-radius: var(--sp3x);
					border-top: 2px solid var(--color2);
					border-right: 2px solid var(--color2);
					border-left: 2px solid var(--color2);
					padding: 14px 14px 0 14px;
					background-color: var(--color1);
					transform: translate3d(0, -100%, 0);

					&::before {
						content: '';
						width: 100%;
						height: 2px;
						position: absolute;
						top: calc(100% - 1px);
						left: 0;
						background-color: var(--color1);
					}
				}

				.category {
					margin-bottom: var(--sp2x);
				}

				.title {
					margin-bottom: var(--sp1x);
					overflow: hidden;
					text-overflow: ellipsis;
					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
				}

				.description {
					margin-bottom: var(--sp3x);
				}

				.readTimeWrap {
					display: flex;
					align-items: center;

					span {
						margin-right: var(--sp2x);
					}
				}
			}

			.blogItemImage {
				height: 100%;
				overflow: hidden;
				margin-top: var(--sp4x);

				> .imageCont {
					height: 100%;
					padding-top: var(--imgSize);
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			padding-top: var(--sp5x);

			.blogCont {
				.blogItemInfo {
					.blogItemDate {
						padding: var(--sp2x) var(--sp2-5x) 0;
					}

					.description {
						margin-bottom: var(--sp4x);
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			--itemMargTop: var(--sp4x);
			--itemMargBottom: var(--sp4x);

			.blogCont {
				display: flex;
				justify-content: space-between;
				flex-wrap: wrap;

				.blogItemImage {
					margin-top: 0;
				}

				.blogItemInfo {
					.description {
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 3;
						-webkit-box-orient: vertical;
					}
				}
			}
		}
		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXSMin}) and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			--imgSize: 64.6%;
			--blogItemInfoTop: var(--sp2x);

			.blogCont {
				.blogItemInfo {
					flex: 0 0 48%;
					max-width: 48%;

					.blogItemDate {
						padding: var(--sp2x) var(--sp2-5x) 0;
					}

					.description {
						margin-bottom: var(--sp2-5x);
					}
				}

				.blogItemImage {
					flex: 0 0 48%;
					max-width: 48%;
				}
			}
		}
		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeSMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			--imgSize: 55.5%;
			--imgSizeHover: 64.6%;
			--blogItemInfoTop: var(--sp1x);

			.blogCont {
				.blogItemInfo {
					flex: 0 0 45%;
					max-width: 45%;

					.description {
						margin-bottom: var(--sp4x);
					}

					.blogItemDate {
						padding: var(--sp2x) var(--sp2-5x) 0;
					}
				}

				.blogItemImage {
					flex: 0 0 48.3%;
					max-width: 48.3%;
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXS}) {
			--bottomItemAnimation: var(--sp28x);

			.blogCont {
				height: 100%;

				.blogItemImage {
					.imageCont {
						transition: all var(--trTime) ease-out;

						.image {
							padding-top: var(--imgSizeHover);
						}
					}
				}

				.blogItemInfo {
					transition: all var(--trTime) ease-out;
					height: 100%;

					.readTimeWrap {
						transform: translate3d(0, var(--bottomItemAnimation), 0);
						transition: all var(--trTime) ease-out;
					}
				}
			}

			@media (hover: none) {
				-webkit-tap-highlight-color: rgba(0, 0, 0, 0);

				&:active {
					--bottomItemAnimation: 0px;
					--blogItemInfoTop: var(--sp2x);
				}
			}

			@media (hover: hover), all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
				&:hover {
					--bottomItemAnimation: 0px;
					--blogItemInfoTop: var(--sp2x);
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeMMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeS}) {
			--imgSize: 55.5%;
			--imgSizeHover: 64%;
			--blogItemInfoTop: var(--sp6x);

			.blogCont {
				.blogItemInfo {
					padding-top: var(--blogItemInfoTop);
					flex: 0 0 48%;
					max-width: 48%;

					.description {
						margin-bottom: var(--sp4x);
					}

					.blogItemDate {
						padding: var(--sp2x) var(--sp4x) 0;
					}
				}

				.blogItemImage {
					flex: 0 0 45%;
					max-width: 45%;
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
			--imgSize: 52%;
			--imgSizeHover: 65%;
			--blogItemInfoTop: var(--sp5x);

			.blogCont {
				.blogItemInfo {
					flex: 0 0 44.5%;
					max-width: 44.5%;

					.description {
						margin-bottom: var(--sp5x);
					}

					.blogItemDate {
						padding: var(--sp2x) var(--sp5x) 0;
					}
				}

				.blogItemImage {
					flex: 0 0 48%;
					max-width: 48%;
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeXLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeL}) {
			--imgSize: 51%;
			--imgSizeHover: 64%;
			--blogItemInfoTop: var(--sp9x);

			.blogCont {
				.blogItemInfo {
					flex: 0 0 49%;
					max-width: 49%;

					.description {
						margin-bottom: var(--sp5x);
					}

					.blogItemDate {
						border-top-left-radius: var(--sp3x);
						border-top-right-radius: var(--sp3x);
						padding: var(--sp2x) var(--sp7x) 0;
					}
				}

				.blogItemImage {
					flex: 0 0 46.6%;
					max-width: 46.6%;
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			--imgSize: 58%;
			--imgSizeHover: 74%;
			--blogItemInfoTop: var(--sp10x);

			&:after {
				left: 0;
			}

			.blogCont {
				.blogItemInfo {
					flex: 0 0 50.5%;
					max-width: 50.5%;

					.category {
						margin-bottom: var(--sp2-5x);
					}

					.title {
						margin-bottom: var(--sp2-5x);
					}

					.description {
						margin-bottom: var(--sp8x);
					}

					.blogItemDate {
						border-top-left-radius: var(--sp4x);
						border-top-right-radius: var(--sp4x);
						padding: 8px 60px 0;
					}
				}

				.blogItemImage {
					flex: 0 0 38.6%;
					max-width: 38.6%;
				}
			}
		}
	}
`;

export default BlogListItemStyle;
